import { toFixedNumber } from "@/utils";

// FIELD KEY GENERAL CONFIG
export const EXTRA_LOYALTY_KEY = "extraLoyalty";
export const CONDITION_MONTH_KEY = "conditionalMonth";
export const LEAVE_HOUR_IN_MONTH_KEY = "leaveHourInMonth";
export const ADVANCE_LEAVE_KEY = "advanceLeave";

// FILE KEY PROJECT LEAVE
export const FINANCIAL_YEAR_KEY = "financialYear";
export const ATTACH_FILE_PATHS_KEY = "attachFilePaths";
export const PROJECT_KEY = "project";

// FILE KEY COMMON
export const LEAVE_DAY_KEY = "leaveDay";
export const LEAVE_HOUR_KEY = "leaveHours";
export const DESCRIPTION_KEY = "description";
export const APPLY_DATE_KEY = "applyDate";
export const EXPIRE_DATE_KEY = "expireDate";

// EXTRA
export const SENIORITY_LEAVE_DAY_EXTRA = "day(s)";
export const SENIORITY_LEAVE_YEAR_EXTRA = "year(s)";
export const CONDITION_MONTH_EXTRA = "% total paid days";
export const LEAVE_DAY_IN_MONTH_EXTRA = "day(s)";
export const LEAVE_HOURS_IN_MONTH_EXTRA = "hour(s)";
export const ADVANCE_LEAVE_EXTRA = "payroll period(s)";

// HISTORY KEY GENERAL CONFIGURATION
export const OBJECT = "object";
export const EXTRA_FOR_LOYALTY = "extraForLoyaltyFormat";
export const CONDITION_MONTH = "conditionMonthFormat";
export const LEAVE_HOUR_IN_MONTH = "leaveHourInMonth";
export const ADVANCE_LEAVE = "advanceLeaveFormat";

// FIELD KEY ONSITE REQUEST
export const FROM_DATE_KEY = "startDate";
export const TO_DATE_KEY = "endDate";
export const DURATION_KEY = "quantityInHours";
export const FROM_SHIFT_KEY = "startShift";
export const TO_SHIFT_KEY = "endShift";
export const STATUS_KEY = "statusType";
export const REASON_KEY = "reasonsForRejection";

export const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];

export const annualLeaveOverviewColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 60,
    align: "right",
  },
  {
    title: "Staff",
    dataIndex: "fullName",
    key: "staff",
    width: 250,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    width: 150,
  },
  {
    title: "Seniority start date",
    dataIndex: "seniorityDate",
    key: "seniorityDate",
    width: 160,
  },
  {
    title: "Seniority",
    dataIndex: "days_seniority",
    key: "seniority",
    customRender(_, record) {
      const { days_seniority, months_seniority, years_seniority } = record;
      return `${years_seniority ?? 0} years ${months_seniority ?? 0} months ${days_seniority ?? 0} days`;
    },
    width: 200,
  },
  {
    title: "Phép khả dụng đầu kỳ (giờ)",
    dataIndex: "availability_begin_period",
    key: "availability_begin_period",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 170,
    align: "right",
  },
  {
    title: "Phép được cộng thêm trong kỳ (giờ)",
    dataIndex: "addition_leave",
    key: "addition_leave",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 180,
    align: "right",
  },
  {
    title: "Phép dùng trong kỳ (giờ)",
    dataIndex: "used_in_period",
    key: "used_in_period",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 160,
    align: "right",
  },
  {
    title: "Phép hết hạn trong kỳ (giờ)",
    dataIndex: "expired",
    key: "expired",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 160,
    align: "right",
  },
  {
    title: "Phép được dùng hiện tại (giờ)",
    dataIndex: "current_leave_fund_availability",
    key: "current_leave_fund_availability",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 160,
    align: "right",
  },
  {
    title: "Phép khả dụng cuối kỳ (giờ)",
    dataIndex: "leave_fund_availability_end_of_period",
    key: "leave_fund_availability_end_of_period",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 160,
    align: "right",
  },
];

export const generalConfigColumns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 80,
    align: "center",
  },
  {
    title: "Extra for Loyalty",
    key: "extra_for_loyalty",
    dataIndex: "extraForLoyaltyFormat",
    width: 250,
  },
  {
    title: "Conditional / Month",
    key: "condition",
    dataIndex: "conditionMonthFormat",
    width: 320,
    align: "right",
  },
  {
    title: "Annual Hour(s) / Month",
    key: "annual_day",
    dataIndex: "annualLeaveHoursInMonth",
    width: 250,
  },
  {
    title: "Advanced Payment Leave",
    key: "advanced_leave",
    dataIndex: "advanceLeaveFormat",
    align: "left",
  },
  {
    title: "Date Applied",
    key: "date_applied",
    dataIndex: "applyDateFormat",
    width: 250,
    align: "center",
  },
  {
    title: "Date Expired",
    key: "date_expired",
    dataIndex: "expireDateFormat",
    width: 250,
    align: "center",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 180,
    fixed: "right",
    align: "center",
  },
];
